import React, { useState } from "react";
import { Spinner } from "reactstrap";
import DataTable from "react-data-table-component";
import CategoryModal from '../components/CategoryModify';

const DataLoader = ({ 
                      isLoading = false, // Default value for isLoading
                      data , // Default value for data
                      options = {}, // Default value for options
                      handleEdit = undefined, // Default value for handleEdit
                      handleDelete = undefined, // Default value for handleDelete
                      reload = () => {}, // Default value for reload
                      rubro = undefined, // Default value for rubro
                      hoverColor = '#f5f5f5', // Default value for hoverColor
                      tdColor = 'inherit' // Default value for tdColor
                    }) => { 

  // console.log('ESTO ES UNA PRUEBA',data);
  
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});

  // Function to open the modal with data
  const openModalWithData = (newFormData) => {
    setFormData(newFormData);
    setModalOpen(true);
  };

  // Function to toggle the modal
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  // Function to modify the row for the "categoria" column
  const categoriafuncion = (row) => {
    const newObject = { ...row };
    const catego = newObject.categoria;
    let operados = catego;

    if (newObject.operado != null) {
      operados += ' *';
    }
    newObject.idcatego = (
      <span 
        onClick={() => openModalWithData(row)} 
        style={{ cursor: "pointer", textDecoration: "underline" }}
      >
        {operados}
      </span>
    );
    return newObject;
  };

  // Prepare columns for DataTable
  const columns = data.columns.map(col => ({
    name: col.label,
    selector: row => row[col.field],
    sortable: col.sort !== 'disabled',
    cell: row => {
      
      if (col.field === 'actions') {
        return (
          <div>
            {handleEdit && (
              <a onClick={() => handleEdit(row)}>
                <i className="mdi mdi-circle-edit-outline" style={{ fontSize: "25px" }}></i>
              </a>
            )}
            {' '}
            {handleDelete && (
              <a onClick={() => handleDelete(row.idunique)}>
                <i className="mdi mdi-delete-circle-outline" style={{ fontSize: "25px" }}></i>
              </a>
            )}
          </div>
        );
      }
      if (col.field === 'idcatego' && rubro !== undefined) {
        return categoriafuncion(row).idcatego;
      }
      return row[col.field];
    }
  }));

  // Apply custom styles to the rows
  const customStyles = {
    rows: {
      style: {
        backgroundColor: tdColor, // Use custom td color
        transition: 'background-color 0.3s ease', // Smooth transition for hover effect
        '&:hover': {
          backgroundColor: hoverColor, // Use custom hover color
        }
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="text-center mt-3">
          <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
        </div>
      ) : (
        data && data.rows && data.rows.length > 0 ? (
          <DataTable
            columns={columns}
            data={data.rows}
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />
        ) : (
          <div className="text-center mt-3">
            No existen datos.
          </div>
        )
      )}

      {/* Category Modal */}
      <CategoryModal
        isOpen={modalOpen}
        toggle={toggleModal}
        formData={formData}
        reload={reload}
        rubro={rubro}
      />
    </>
  );
};

export default DataLoader;